import React from 'react';
import { motion } from 'motion/react';

const FloatingElements = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {/* Gradiente de fundo suave */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 100% 100% at 50% 0%, rgba(0, 128, 85, 0.04) 0%, transparent 50%)',
        }}
      />

      {/* Grid de pontos sutil */}
      <div 
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `radial-gradient(circle, #008055 1px, transparent 1px)`,
          backgroundSize: '50px 50px',
        }}
      />

      {/* Gráfico de crescimento - Esquerda (hidden on mobile) */}
      <motion.svg
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="hidden lg:block absolute left-8 top-1/4 w-64 h-48 opacity-[0.08]"
        viewBox="0 0 200 150"
        fill="none"
      >
        {/* Barras do gráfico */}
        <motion.rect
          x="20" y="100" width="20" height="40"
          fill="#008055"
          initial={{ height: 0, y: 140 }}
          animate={{ height: 40, y: 100 }}
          transition={{ duration: 1, delay: 0.8 }}
        />
        <motion.rect
          x="50" y="80" width="20" height="60"
          fill="#008055"
          initial={{ height: 0, y: 140 }}
          animate={{ height: 60, y: 80 }}
          transition={{ duration: 1, delay: 1 }}
        />
        <motion.rect
          x="80" y="60" width="20" height="80"
          fill="#008055"
          initial={{ height: 0, y: 140 }}
          animate={{ height: 80, y: 60 }}
          transition={{ duration: 1, delay: 1.2 }}
        />
        <motion.rect
          x="110" y="40" width="20" height="100"
          fill="#008055"
          initial={{ height: 0, y: 140 }}
          animate={{ height: 100, y: 40 }}
          transition={{ duration: 1, delay: 1.4 }}
        />
        <motion.rect
          x="140" y="20" width="20" height="120"
          fill="#008055"
          initial={{ height: 0, y: 140 }}
          animate={{ height: 120, y: 20 }}
          transition={{ duration: 1, delay: 1.6 }}
        />
        {/* Linha de crescimento */}
        <motion.path
          d="M30 100 L60 80 L90 60 L120 40 L150 20"
          stroke="#D98A8C"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 1 }}
        />
        {/* Pontos na linha */}
        <motion.circle cx="30" cy="100" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.2 }} />
        <motion.circle cx="60" cy="80" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.4 }} />
        <motion.circle cx="90" cy="60" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.6 }} />
        <motion.circle cx="120" cy="40" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.8 }} />
        <motion.circle cx="150" cy="20" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 2 }} />
      </motion.svg>

      {/* Gráfico de pizza/donut - Direita superior (hidden on mobile) */}
      <motion.svg
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
        className="hidden lg:block absolute right-16 top-20 w-40 h-40 opacity-[0.1]"
        viewBox="0 0 100 100"
      >
        <circle cx="50" cy="50" r="40" fill="none" stroke="#E6E4EB" strokeWidth="12" />
        <motion.circle
          cx="50" cy="50" r="40"
          fill="none"
          stroke="#008055"
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray="251.2"
          strokeDashoffset="251.2"
          initial={{ strokeDashoffset: 251.2 }}
          animate={{ strokeDashoffset: 75 }}
          transition={{ duration: 2, delay: 1 }}
          transform="rotate(-90 50 50)"
        />
        <motion.circle
          cx="50" cy="50" r="40"
          fill="none"
          stroke="#E1C567"
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray="251.2"
          strokeDashoffset="251.2"
          initial={{ strokeDashoffset: 251.2 }}
          animate={{ strokeDashoffset: 175 }}
          transition={{ duration: 2, delay: 1.5 }}
          transform="rotate(50 50 50)"
        />
      </motion.svg>

      {/* Linha de tendência - Direita (hidden on mobile) */}
      <motion.svg
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1 }}
        className="hidden lg:block absolute right-12 bottom-1/4 w-56 h-32 opacity-[0.08]"
        viewBox="0 0 200 100"
        fill="none"
      >
        {/* Grid de fundo */}
        <line x1="0" y1="25" x2="200" y2="25" stroke="#CBC9CF" strokeWidth="0.5" />
        <line x1="0" y1="50" x2="200" y2="50" stroke="#CBC9CF" strokeWidth="0.5" />
        <line x1="0" y1="75" x2="200" y2="75" stroke="#CBC9CF" strokeWidth="0.5" />
        
        {/* Linha de crescimento ondulada */}
        <motion.path
          d="M0 80 Q25 70 50 65 T100 45 T150 30 T200 10"
          stroke="#008055"
          strokeWidth="3"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2.5, delay: 1.2 }}
        />
        {/* Área preenchida abaixo da linha */}
        <motion.path
          d="M0 80 Q25 70 50 65 T100 45 T150 30 T200 10 L200 100 L0 100 Z"
          fill="url(#gradient1)"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.3 }}
          transition={{ duration: 1, delay: 2 }}
        />
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#008055" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#008055" stopOpacity="0" />
          </linearGradient>
        </defs>
      </motion.svg>

      {/* Ícones de engajamento flutuantes (hidden on mobile) */}
      <motion.div
        animate={{ y: [0, -15, 0] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        className="hidden md:block absolute left-[15%] top-[15%]"
      >
        <svg className="w-10 h-10 opacity-[0.12]" viewBox="0 0 24 24" fill="#D98A8C">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      </motion.div>

      <motion.div
        animate={{ y: [0, -12, 0] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        className="hidden md:block absolute right-[20%] top-[45%]"
      >
        <svg className="w-8 h-8 opacity-[0.12]" viewBox="0 0 24 24" fill="#E1C567">
          <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
        </svg>
      </motion.div>

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
        className="hidden md:block absolute left-[25%] bottom-[20%]"
      >
        <svg className="w-9 h-9 opacity-[0.12]" viewBox="0 0 24 24" fill="#008055">
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
        </svg>
      </motion.div>

      {/* Seta de crescimento grande (hidden on mobile) */}
      <motion.svg
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
        className="hidden md:block absolute right-[8%] top-[60%] w-24 h-24 opacity-[0.06]"
        viewBox="0 0 24 24"
        fill="#008055"
      >
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </motion.svg>

      {/* Calendário/Schedule ícone (hidden on mobile) */}
      <motion.div
        animate={{ y: [0, -8, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        className="hidden md:block absolute left-[8%] bottom-[35%]"
      >
        <svg className="w-12 h-12 opacity-[0.08]" viewBox="0 0 24 24" fill="#DFB573">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
        </svg>
      </motion.div>

      {/* Conexões/Network lines (hidden on mobile) */}
      <svg className="hidden lg:block absolute inset-0 w-full h-full opacity-[0.04]">
        <motion.line
          x1="10%" y1="20%" x2="30%" y2="35%"
          stroke="#008055"
          strokeWidth="1"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 0.5 }}
        />
        <motion.line
          x1="30%" y1="35%" x2="25%" y2="60%"
          stroke="#008055"
          strokeWidth="1"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 1 }}
        />
        <motion.line
          x1="70%" y1="25%" x2="85%" y2="45%"
          stroke="#D98A8C"
          strokeWidth="1"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 0.8 }}
        />
        <motion.line
          x1="85%" y1="45%" x2="75%" y2="70%"
          stroke="#D98A8C"
          strokeWidth="1"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 1.3 }}
        />
        
        {/* Pontos de conexão */}
        <motion.circle cx="10%" cy="20%" r="4" fill="#008055" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.5 }} />
        <motion.circle cx="30%" cy="35%" r="4" fill="#008055" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1 }} />
        <motion.circle cx="25%" cy="60%" r="4" fill="#008055" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.5 }} />
        <motion.circle cx="70%" cy="25%" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.8 }} />
        <motion.circle cx="85%" cy="45%" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.3 }} />
        <motion.circle cx="75%" cy="70%" r="4" fill="#D98A8C" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.8 }} />
      </svg>

      {/* Blobs de gradiente suaves (always visible) */}
      <motion.div
        animate={{ 
          y: [0, -30, 0],
          x: [0, 15, 0]
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut'
        }}
        className="absolute -left-20 top-1/3 w-72 md:w-96 h-72 md:h-96 rounded-full blur-[100px] md:blur-[120px]"
        style={{
          background: 'radial-gradient(circle, rgba(217, 138, 140, 0.2) 0%, transparent 70%)'
        }}
      />
      <motion.div
        animate={{ 
          y: [0, -25, 0],
          x: [0, -20, 0]
        }}
        transition={{
          duration: 18,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut',
          delay: 2
        }}
        className="absolute -right-20 top-1/2 w-60 md:w-80 h-60 md:h-80 rounded-full blur-[80px] md:blur-[100px]"
        style={{
          background: 'radial-gradient(circle, rgba(225, 197, 103, 0.15) 0%, transparent 70%)'
        }}
      />
      <motion.div
        animate={{ 
          y: [0, -20, 0],
          x: [0, 10, 0]
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          repeatType: 'reverse',
          ease: 'easeInOut',
          delay: 1
        }}
        className="absolute left-1/4 -bottom-20 w-56 md:w-72 h-56 md:h-72 rounded-full blur-[80px] md:blur-[100px]"
        style={{
          background: 'radial-gradient(circle, rgba(0, 128, 85, 0.12) 0%, transparent 70%)'
        }}
      />
    </div>
  );
};

export default FloatingElements;
